const configuration = {
  backButton: "Back to Home",
  units: {
    title: "Currency",
    mainTitle: "Currency Conversion Management",
    tableTitle: "Currency",
    tableDescription:
      "Currencies are used to enter claims in their original currency. Each case has a default currency, and all other currencies will be converted into the default currency by multiplying the currency by the currency's Exchange Rate to yield the equivalent default currency amount. The default currency for the case cannot be changed. The Decimal point is used for display purposes, but the system will record values with more decimals as required. Recommend the use of ISO 4217 Currency codes (https://www.six-group.com/dam/download/financial-information/data-center/iso-currrency/lists/list-one.xls). Currencies can also be used for identification of Crypto currencies. When used for crypo currencies, set the decimal places to an appropriate value such as 8. Currencies can also be used for claims on bond issues, where it is desirable to enter the face amount of the bond, and use the Exchange Rate to apply a consistent conversion into the default currency for the case.",
    newUnit: "New Currency",
    successfullyDeleted: "Currency deleted successfully.",
    deleteConfirmationMessage:
      "Are you sure you want to delete this Unit: <strong>{{unitName}}</strong>?",
    tableColumnDetails: {
      column1: "Default",

      column2: "Currency Name",

      column3: "Description",

      column4: "Exchange Rate",

      column5: "Decimal Places",
    },
    createUnit: {
      primaryTitle: "Currency Setup",
      primaryDescription:
        "Currencies are used to enter claims in their original currency. Each case has a default currency, and all other currencies will be converted into the default currency by multiplying the currency by the currency's Exchange Rate to yield the equivalent default currency amount. The default currency for the case cannot be changed. The Decimal point is used for display purposes, but the system will record values with more decimals as required. Recommend the use of ISO 4217 Currency codes (https://www.six-group.com/dam/download/financial-information/data-center/iso-currrency/lists/list-one.xls). Currencies can also be used for identification of Crypto currencies. When used for crypo currencies, set the decimal places to an appropriate value such as 8. Currencies can also be used for claims on bond issues, where it is desirable to enter the face amount of the bond, and use the Exchange Rate to apply a consistent conversion into the default currency for the case.",
      secondaryTitle: "Currency Details",
      secondaryDescription:
        "Lorem ipsum dolor sit amet consectetur. Pulvinar aliquet a odio",
    },
    formLabels: {
      unitIdentification: "Currency Identification",
      unitName: "Currency Name",
      rate: "Exchange Rate",
      decimalRate: "Decimal Places",
      unitDescription: "Description",
      defaultCurrency: "Make this the default currency",
      includeFrench: "I want to include case identifiers in French.",
      french: "French",
      unitNameFrench: "Currency Name (French)",
      unitDescriptionFrench: "Currency Description (French)",
      removeSection: "Remove section",
      currencyUnselect:
        "Are you sure you want to unselect this Currency as Default Currency?",
      currencySelect:
        "Are you sure you want to select this Currency as Default Currency?",
    },
    validationMessages: {
      unitNameRequired: "Currency Name is required",
      unitExists:
        "Entered Currency Name already existing, please enter other Currency Name",
      validName: "Please enter a valid Currency Name",
      rateRequired: "Rate is required",
      rateMustNumber: "Rate must be a number",
      decimalPlaceRequired: "Decimal Place is required",
      unitDescriptionRequired: "Currency Description is required",
      exchangeRateMessage: "Default Currency's Exchange Rate must be '1'",
      decimalMustNumber: "Decimal Place must be a number",
    },
  },
  caseZone: {
    title: "Case Time Zones",
    description:
      "The Case Time Zone will be used to timestamp all logged entries, and should reflect the primary timezone for the administration of the case.",
    timeZone: "Time Zone",
    timeZoneRequired: "The Time Zone cannot be empty or contain only spaces.",
  },
  caseTimeZones: {
    title: "Case Time Zones",
  },
  attributes: {
    title: "Attributes",
    subtitle: "Attribute Management",
    attributeTableName: "Attribute Name",
    attributeTableType: "Type",
    attributeTableDescription: "Description",
    attributeType: "Attribute Type",
    attributeTypeCreditor: "Creditor",
    attributeTypeClaim: "Claim",
    attributeTypeClaimItem: "Claim Element",
    createAttributeButton: "New Attribute",
    backButton: "Back",
    attributeSetup: "Attribute Setup",
    cancelButton: "Cancel",
    reviewButton: "Review and Submit",
    submitButton: "Submit",
    deleteButton: "Delete",
    deleteAttribute: "Delete Attribute",
    deleteAttributeMessage:
      "Are you sure you want to delete this Attribute: <strong>{{attributeName}}</strong>?",
    requiredFields: "Please fill out all required attribute fields.",
    sameAttributeName:
      "Unable to create Attribute as Attribute Name already exists in the case",
    createAttribute: {
      regexPattern: "Regex Pattern",
      warningMessage: "Warning Message",
      missingConfig: "Missing configuration for attribute",
      title1: "Create",
      title2: "Attribute",
      attributeName: "Attribute Name",
      attributeNameFrench: "French Attribute Name",
      attributeDescription: "Attribute Description",
      attributeDescriptionFrench: "French Attribute Description",
      attributeType: "Attribute Type",
      freeText: "Free-Text",
      date: "Date",
      singleSelect: "Single Select",
      multiSelect: "Multi Select",
      boolean: "Boolean",
      currency: "Currency",
      number: "Number",
      document: "Document",
      requiredAttribute: "Make this attribute required",
      displayAttribute: "Display this attribute during creation",
      format: "Format",
      sinNumber: "SIN Number Format",
      sinNumberIsNotValidFormate: "{{attributeName}} not a valid SIN number",
      email: "Email Format",
      regularExpression: "Regular Expression",
      telephone: "North American Telephone Format",
      postalCode: "Canadian Postal Code Format",
      none: "None",
      maxCharacter: "Max Character Limit",
      maskInput: "Mask input when displayed",
      value: "Value",
      option: "Option",
      addValue: "Add Another Value",
      defaultOption: "Default Option",
      defaultValue: "Default Value",
      yes: "Yes",
      no: "No",
      numberFormat: "Number Format",
      integer: "Integer",
      decimal: "Decimal",
      maxNumber: "Maximum Number",
      minNumber: "Minimum Number",
      fileFormat: "Accepted File Format",
      attributeDetails: "Attribute Details",
    },
    requiredError:
      "is a required field, please resolve the error before saving.",
    minMaxRangeError: "Minimum Number cannot be greater than Maximum Number.",
    numberError: "Please enter a number between ",
    sinError: "format needs to be 9 digits long.",
    emailError: "Email format is invalid.",
    regexError: "Expression is in invalid format.",
    phoneError: "format needs to be 10 digits long.",
    postalError:
      "format needs to be  'ANA NAN', where 'A' represents a letter and 'N' represents a number.",
    fileError: "File format is invalid.",
  },
  stages: {
    title: "Stages",
    subtitle: "Stage Management",
    addNewButton: "Add New",
    newStage: "New Stage",
    newStatus: "New Status",
    status: "Status",
    initialPortal: "Initial status",
    requireDocument: "Require document attachment",
    releaseDocument: "Release document attached in this status",
    resolveStatus: "Resolve status",
    portalStatus: "Portal Status",
    dueDateType: "Due Date Type",
    timeLimit: "Time Limit",
    deadline: "Deadline",
    timeLimitDays: "Time Limit (in Days)",
    deadlineDate: "Deadline Date",
    addStage: "Add New Stage",
    editStage: "Edit Stage",
    stageName: "Stage Name",
    stageNameFrench: "Stage Name (French)",
    stageDescription: "Stage Description",
    stageDescriptionFrench: "Stage Description (French)",
    position: "Position",
    creditorPosition: "Creditor Position",
    debtorPosition: "Debtor Position",
    addStatus: "Add New Status",
    editStatus: "Edit Status",
    statusName: "Status Name",
    statusNameFrench: "Status Name (French)",
    statusDescription: "Status Description",
    statusDescriptionFrench: "Status Description (French)",
    deleteStage: "Delete Stage",
    deleteStageMessage:
      "Are you sure you want to delete this Stage: <strong>{{name}}</strong>?",
    deleteStatus: "Delete Status",
    deleteStatusMessage:
      "Are you sure you want to delete this Status: <strong>{{name}}</strong>?",
    edit: "Save",
    add: "Add",
    confirm: "Confirm",
    cancel: "Cancel",
    initialStatusUsedMessage: "Cannot delete an initial status",
  },
  category: {
    title: "Categories",
    tableTitle: "Category",
    createCategory: "New Category",
    deleteCategoryMessage:
      "Are you sure you want to delete this Category: <strong>{{categoryName}}</strong>?",
    deleteMesseage: "Unable to delete category as it is currently in use.",
    deleteSuccessfully: "Category deleted successfully.",
    tableDescription:
      "These categories will be used to identity claim elements that have similar natures. A claim can contain multiple claim elements with different categories.",
    columnDetails: {
      column1: "Category Name",

      column2: "Description",
    },
    validationMessages: {
      categoryRequired: "Category Name is required",
    },
    formLabels: {
      categoryName: "Category Name",
      categoryDescription: "Category Description",
      categoryNameFrench: "Category Name (French)",
      categoryDescriptionFrench: "Category Description (French)",
    },
    bannerLabels: {
      categoryName: "Category Name",
      createdOn: "Created On",
    },
    categoryEditTitle: "Edit Category",
    categoryCreateTitle: "Category Setup",
    categoryCreateDescription: `A Category represent the nature of the claim. Common Categories include: Trade, Taxes, Legal, Landlord, Interest, Debt, etc. These Categories can be customized as necessary for each case.`,
  },
  schemes: {
    title: "Schemes and Classes",
    tableTitle: "Schemes Classes",
    tableDescription:
      "A Scheme is a collection of Classes that are applied to all Claim Elements. Schemes and Classes are used for Voting and Distribution purposes. Every Claim Element will be assigned a Class under every Scheme.  While the Classes in a case may follow a legal definition, in this application that would represent a single Scheme. Having alternative Schemes can facilitate other ways of grouping claims, for example the case may also have a 'Mailing Scheme' that assigns claims to one of 3 classes: 'Canadian', 'USA', and 'International'.",
    createScheme: "New Scheme",
    columnDetails: {
      column1: "Scheme Name",

      column2: "Description",

      column3: "Effective Date",
    },
  },
  scheme: {
    editSchemeTitle: "Edit Scheme",
    schemeBanner: {
      bannerTitle: "Scheme Name",
      lastEffectiveDate: "Last Effective Date",
    },
    formLabels: {
      schemeName: "Scheme Name",
      schemeNameFrench: "Scheme Name (French)",
      schemeDescription: "Scheme Description",
      schemeDescriptionFrench: "Scheme Description (French)",
      addNewRule: "Add a new rule",
      name: "Name",
      description: "Description",
      nameFrench: "Name (French)",
      descriptionFrench: "Description (French)",
    },
    classColumnDetails: {
      column1: "Class Name",

      column2: "Rule Count",

      column3: "Default",

      column4: "Description",
    },
    rulesColumnDetails: {
      column1: "Rule Name",

      column2: "Description",

      column3: "Class Name",
    },
    validationMessages: {
      schemeRequired: "Scheme Name is required",
      schemeVersionMessage: "Scheme version could not be loaded",
      schemeUpdateSuccess: "Scheme updated successfully",
      schemeFailed: "Failed to update scheme",
      schemeEffectiveWarningMessage:
        "Are you sure you would like make scheme again after the current classification is completed?",
    },
    primaryTitle: "Scheme Setup",
    primaryDescription:
      "A Scheme is a collection of Classes that are applied to all Claim Elements. Schemes and Classes are used for Voting and Distribution purposes. Every Claim Element will be assigned a Class under every Scheme.  While the Classes in a case may follow a legal definition, in this application that would represent a single Scheme. Having alternative Schemes can facilitate other ways of grouping claims, for example the case may also have a 'Mailing Scheme' that assigns claims to one of 3 classes: 'Canadian', 'USA', and 'International'.",
    secondaryTitle: "Create Scheme",
    secondaryDescription:
      "Lorem ipsum dolor sit amet consectetur. Fringilla pulvinar in sed volutpat. Nunc iaculis cras amet condimentum. Bibendum.",
    manageSetup: "Manage Scheme",
    schemeDetails: "Scheme Details",
    detailDescription:
      "A Scheme is a collection of Classes that are applied to all Claim Elements. Schemes and Classes are used for Voting and Distribution purposes. Classes have Rules that are used to assign Claim Elements to that Class. The Rules are processed in order, all Claim Elements that satisfy the Rule, cause those Claim Elements to be assigned the Rules corresponding Class. Only unclassified Claim Elements are considered for all subsequent Rules. If, after processing all the Rules, there remain unclassified Claim Elements, those Claim Elements will be assigned the default Class.",
    classTableDescription:
      "Classes are used to group Claim Elements that should be treated in the same way within a scheme. For example Class A creditors, or a Convenience Class. They can also be used to group or filter Claim Elements within distribution calculations, or to identify mailing destinations.",
    rulesTableDescription:
      "Rules are processed sequentially to assign Claim Elements into Classes. Each Rule belongs to only one Class, but Classes can have multiple Rules. Any unclassified Claim Elements that remain after all Rules have been applied will be classified into the default Class.",
    schemeEffective: "Make this scheme effective",
    generateSchemeReport: "Generate Scheme Report",
    edit: "Edit",
    manageRuleAndClass: "Manage Classes & Rules",
    manageRulesAndClassDescription:
      "Every Claim Element in the case is assigned a class under this scheme using the 'Current Effective Scheme'. When making changes to the Scheme, these are held in 'draft' until the 'Make this scheme effective' button is pressed. Historical definitions of this scheme are available for review using the 'View Version' drop-down.",
    preview: "Preview",
    viewVersion: "View Version",
    classes: "Classes",
    rules: "Rules",
    newClassButton: "Add a new class",
    noRecord: "No record found.",
    previewTableTitle: "Preview",
    previewTableDescription: "Creditors list related to the case",
    previewColumns: {
      column1: "Name",
      column2: "Total Claims",
      column3: "Original Amount {{unitName}}",
      column4: "Claim Amount {{unitName}}",
      column5: "Latest Creditor Position Amount {{unitName}}",
      column6: "Latest Debtor Position Amount {{unitName}}",
      column7: "Resolved Amount {{unitName}}",
    },
    noClaimFound: "No claim found.",
    previewSchemeButton: "Preview Scheme",
    previewFilter: "Filter",
    previewBasicSearch: "Basic search",
    clearSearch: "Clear Search",
    lodaingIteamsMessage: "Loading Claim Element details...",
    noClaimData: "There is no claim data",
    makeSchemeEffectiveErrorMessage:
      "Please ensure valid Classes and Rules are configured.",
    schemeProcessingMessage:
      "Scheme is still being made effective. Please do not update the scheme in the meantime.",
    schemeProcessingErrorMessage:
      "Unable to make scheme effective.{{errorMessage}}",
    makeSchemeEffective: "Make Scheme Effective",
    effectiveLoaderTitle: "Making Scheme Effective",
    schemeEffectiveSuccess: "{{schemeName}} has been made effective.",
    previewTitle: "Preview",
    previewDescription:
      "This preview allows you to select a creditor, and view how the components of each of that creditor's claim(s) would be classified using the selected version of the current scheme. There are 2 tables, the first allows for the selection of the creditor(s) to preview, and the second shows the class for each Claim Element of each Claim.",
    ruleBannerDetails: {
      title: "Rule Name",
      label1: "Class Name",
      label2: "Scheme Name",
      label3: "Updated On",
    },
    rule: {
      errorMessage:
        "An error occurred while processing the update. Please try again later.",
      updatedSuccessfully: "Rule updated successfully.",
      ruleConfiguration: "Rule Configuration",
      description: "Description",
      ruleName: "Rule Name",
      ruleLogic: "Rule Logic",
      ruleLogicDescription: "Creditors list related to the case",
      attributes: "Attributes",
      operator: "Operator",
      value: "Value",
      add: "+Add",
      and: "AND",
      or: "OR",
      cancel: "Cancel",
      save: "Save",
      close: "Close",
      deleteRule: "Delete Rule",
      deleteRuleMessage:
        "Are you sure you want to delete this Rule: <strong>{{ruleName}}</strong>?",
      validationError: "Please ensure all fields are filled.",
      addRow: "Add Row",
      addGroup: "Add Group",
      noConditionAdded: "Must configure at least 1 condition",
    },
    class: {
      addClass: "Add a New Class",
      editClass: "Edit Class",
      className: "Class Name",
      classNameFrench: "Class Name (French)",
      classDescriptionFrench: "Class Description (French)",
      classDescription: "Class Description",
      save: "Save",
      cancel: "Cancel",
      deleteClass: "Delete Class",
      deleteClassMessage:
        "Are you sure you want to delete this Class: <strong>{{className}}</strong>?",
      confirm: "Confirm",
      defaultClass: "Make this the default class",
    },
  },
  accounts: {
    deleteAccount: "Delete Account",
    deleteAccountMessage:
      "Are you sure you want to delete this account <strong>{{accountName}}</strong>?",
    deleteSubAccount: "Delete Sub Acoount",
    deleteSubAccountMessage:
      "Are you sure you want to delete this sub account <strong>{{accountName}}</strong>?",
  },
};

export default configuration;
